var React = require('react');
var Col = require('react-bootstrap').Col;
var Row = require('react-bootstrap').Row;

var Config = require('../../config/Config');

var Support = React.createClass({
    render: function () {
        return <section id="support">
            <h2>Infinite Networks Support</h2>
            <Row>
                <Col md={6}>
                    <section className="powerwidget">
                        <header><h2>Technical Support</h2></header>
                        <div className="inner-spacer">
                            <p>
                                To get help faster send your request using this button with all the details
                                we need to start investigating your issue.
                            </p>
                            <p>
                                <a className="btn btn-primary" href="mailto:support@infinite.net.au">Contact Support</a>
                            </p>
                        </div>
                    </section>

                    <section className="powerwidget">
                        <header><h2>Billing &amp; Account Enquiries</h2></header>
                        <div className="inner-spacer">
                            <p>
                                If you couldn't find the information you require in the accounting section
                                contact our accounts team by clicking the button below.
                            </p>
                            <p>
                                <a className="btn btn-primary" href="mailto:accounts@infinite.net.au">Contact Accounts</a>
                            </p>
                        </div>
                    </section>

                    <section className="powerwidget">
                        <header><h2>Sales &amp; General Enquiries</h2></header>
                        <div className="inner-spacer">
                            <p>
                                For Sales and general enquiries contact us by clicking the button below.
                            </p>
                            <p>
                                <a className="btn btn-primary" href="mailto:sales@infinite.net.au">Contact Sales</a>
                            </p>
                        </div>
                    </section>

                    <section className="powerwidget">
                        <header><h2>Phone</h2></header>
                        <div className="inner-spacer">
                            <p>
                                For phone enquiries please contact us on {Config.contactPhone} between 8:30am and
                                5:00pm on weekdays except public holidays in the ACT.
                            </p>
                        </div>
                    </section>
                </Col>
            </Row>
        </section>;
    }
})
module.exports = Support;



// WEBPACK FOOTER //
// ./app/components/Support/Support.js